<template>
  <ckeditor
    :editor="editor"
    @input="handleInput"
    @ready="ckEditorReady"
  ></ckeditor>
  <!--  <input @input="handleInput">-->
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  /*prop: {
    value: {
      type: String,
      default: ''
    }
  },*/
  model: {
    prop: "value",
    event: "blur",
  },
  data: () => ({
    editor: ClassicEditor,
  }),
  mounted() {
    // console.log("mounted value:: ", this.value);
  },
  methods: {
    handleInput(value) {
      // console.log("handleInput:: ", value);
      this.$emit("blur", value);
    },
    updateInput(value) {
      /*this.$emit('input', value)*/
      // console.log("updateInput:: ", value);
      this.$emit("input", this.$el.innerText);
    },
    ckEditorReady(editor) {
      //editor.ui.view.editable.element.style.minHeight = "100px";
    },
  },
};
</script>
